// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"41502e46","686":"5ecf908a"}[chunkId] + ".chunk.js";
};